export var investmentProducts = [
    {
        name: "Bonds",
        icon: "edel-icon-bonds",
        subtext: "",
    },
    {
        name: "Primary NCD",
        icon: "edel-icon-primary-ncd",
        subtext: "",
    },
    {
        name: "Life Insurance",
        icon: "edel-icon-life-insurance-ao",
        subtext: "",
    },
    {
        name: "IPO",
        icon: "edel-icon-ipo",
        subtext: "",
    },
    {
        name: "PMS",
        icon: "edel-icon-pms-ao",
        subtext: "",
    },
    {
        name: "Corporate FD",
        icon: "edel-icon-corporate-fd",
        subtext: "",
    },
    {
        name: "AIFs",
        icon: "edel-icon-aifs",
        subtext: "",
    },
    {
        name: "Sovereign Gold Bonds",
        icon: "",
        subtext: "Gold-backed investment",
    },
    {
        name: "Unlisted Stocks",
        icon: "",
        subtext: "Private equity shares",
    },
    {
        name: "RBI Bonds",
        icon: "",
        subtext: "Government-backed bonds",
    },
    {
        name: "Capital Gain Bonds (54 EC)",
        icon: "",
        subtext: "Tax-saving instruments",
    },
    {
        name: "Structured Products",
        icon: "",
        subtext: "Customized financial instruments",
    },
    {
        name: "General Insurance",
        icon: "",
        subtext: "Non-life coverage policies",
    },
    {
        name: "Housing Loan",
        icon: "",
        subtext: "Home purchase financing",
    },
    {
        name: "NCD",
        icon: "",
        subtext: "Non-Convertible Debentures",
    },
];
export var allInOneProducts = [
    {
        name: "Equity",
        icon: "edel-icon-equity-ao",
        subtext: "Securities Market Trading Facility",
    },
    {
        name: "ETFs",
        icon: "edel-icon-etfs",
        subtext: "Securities Market Trading Facility",
    },
    {
        name: "Mutual Fund",
        icon: "edel-icon-mutual-fund",
        subtext: "Securities Market Trading Facility",
    },
    {
        name: "Commodity",
        icon: "edel-icon-commodity-ao",
        subtext: "Securities Market Trading Facility",
    },
    {
        name: "Currency",
        icon: "edel-icon-currency-ao",
        subtext: "Securities Market Trading Facility",
    },
    {
        name: "Derivatives",
        icon: "edel-icon-derivatives",
        subtext: "Securities Market Trading Facility",
    },
    {
        name: "Buy Back",
        icon: "edel-icon-buy-back",
        subtext: "Securities Market Trading Facility",
    },
    {
        icon: "",
        name: "Preference Shares",
        subtext: "Priority Stocks",
    },
    {
        icon: "",
        name: "SMTF",
        subtext: "Securities Market Trading Facility",
    },
    {
        icon: "",
        name: "ESOP",
        subtext: "Employee Stock Option",
    },
    {
        icon: "",
        name: "LAS",
        subtext: "Loan Against Securities",
    },
    {
        icon: "",
        name: "NFO",
        subtext: "New Fund Offer",
    },
    {
        icon: "",
        name: "OFS",
        subtext: "Offer For Sale",
    },
    {
        icon: "",
        name: "Rights",
        subtext: "Share Purchase Privilege",
    },
    {
        icon: "",
        name: "Buyback",
        subtext: "Company Repurchasing Shares",
    },
    {
        icon: "",
        name: "LAP",
        subtext: "Loan Against Properties",
    },
    {
        icon: "",
        name: "IDR",
        subtext: "Indian Depository Receipt",
    },
    {
        icon: "",
        name: "Small Case",
        subtext: "Thematic Investment Portfolio",
    },
    {
        icon: "",
        name: "SLBM",
        subtext: "Securities Lending & Borrowing",
    },
    {
        icon: "",
        name: "Infinity",
        subtext: "Subscription Fee Program",
    },
    {
        icon: "",
        name: "Commercial Paper",
        subtext: "Short-Term Debt Instrument",
    },
    {
        icon: "",
        name: "Warrant",
        subtext: "Long-Term Equity Option",
    },
    {
        icon: "",
        name: "INVITS",
        subtext: "Company Repurchasing Shares",
    },
    {
        icon: "",
        name: "REITS",
        subtext: "Real Estate Trusts",
    },
];
